import { ReduxAsyncActionsService } from '../../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import { GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS } from '../actions/getSANAdPartnerZeitStatus';
import { INIT_STATE } from './Pinterest.constants';
import type { PinterestState } from './Pinterest.types';
import { GET_PINTEREST_AD_ACCOUNTS, GET_PINTEREST_AUTHENTICATION_URL } from './actions';
import type { PinterestAction } from './actions';

function handler(state: WrappedReducer<PinterestState>, action: PinterestAction): WrappedReducer<PinterestState> {
  switch (action.type) {
    case GET_PINTEREST_AD_ACCOUNTS.response:
      const { accounts } = action.data;
      return {
        ...state,
        adAccounts: accounts,
        loading: false,
      };

    case GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS.response:
      const { a_pinterest } = action.data || {};
      return {
        ...state,
        adAccountStatuses: a_pinterest,
        loading: false,
      };

    case GET_PINTEREST_AUTHENTICATION_URL.response:
      const { url } = action.data;
      return {
        ...state,
        authenticationUrl: url,
        loading: false,
      };

    default:
      return state;
  }
}

const Pinterest = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_PINTEREST_AD_ACCOUNTS, GET_PINTEREST_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS],
  error: [GET_PINTEREST_AD_ACCOUNTS, GET_PINTEREST_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS],
  resetOn: ['APP_CHANGE'],
});

export default Pinterest;
